import { render } from "./OurServicesSectionCMS.vue?vue&type=template&id=1204a314"
import script from "../js/our-services-section-cms.js?vue&type=script&lang=js"
export * from "../js/our-services-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__